/* TOGGLES DE LA PRODUCT PAGE */

document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".toggle-container");

  toggles.forEach((toggle) => {
    const btn = toggle.querySelector(".toggle-btn");
    const content = toggle.querySelector(".toggle-content");

    btn.addEventListener("click", () => {
      // Alternar clase
      toggle.classList.toggle("active");

      // Cálculo de altura dinámica para animar mejor
      if (toggle.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = null;
      }
    });
  });
});

